import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-book-open-line", title: "海量双女主资源", desc: "覆盖校园、奇幻、恋爱、悬疑等多样题材，持续收录优质韩漫。" },
  { icon: "ri-flashlight-line", title: "最新章节速递", desc: "热门作品更新第一时间同步，追更不再错过任何一话。" },
  { icon: "ri-shield-check-line", title: "高清稳定阅读", desc: "清晰画质配合舒适排版，电脑与手机都能顺畅浏览。" },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-sm font-medium text-accent-600">关于双女漫</span>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              免费在线阅读，专注双女主剧情的韩漫平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              双女漫致力于聚合双女主题材的优质韩漫，让喜欢这类故事的读者能够便捷浏览、精准筛选、畅快追更。
              我们从题材、状态到风格标签提供多维度筛选，帮助你在海量作品里快速找到那一部「对的故事」。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站所有漫画内容均为演示样例，用于展示平台功能与浏览体验，正式内容待版权合作接入。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多 <i className="ri-arrow-right-s-line text-lg" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}